import {useMediaQuery} from 'react-responsive'

export default function useResponsiveQuery(){
    return useMediaQuery({ query: '(max-width: 767px)' })
}
